var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMobileHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 45,
  height: 45,
  viewBox: "0 0 45 45",
  preserveAspectRatio: "xMidYMid meet"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "mobileHome")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "house"
}, /*#__PURE__*/React.createElement("g", {
  id: "house-2",
  "data-name": "house"
}, /*#__PURE__*/React.createElement("g", {
  id: "circle"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 22.5,
  cy: 22.5,
  r: 20.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.5,2A20.5,20.5,0,1,1,2,22.5,20.53,20.53,0,0,1,22.5,2m0-2A22.5,22.5,0,1,0,45,22.5,22.52,22.52,0,0,0,22.5,0Z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "house-3",
  "data-name": "house"
}, /*#__PURE__*/React.createElement("rect", {
  x: 12.18,
  y: 19.5,
  width: 21,
  height: 16,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: 16.18,
  y: 19.5,
  width: 5,
  height: 5
}), /*#__PURE__*/React.createElement("rect", {
  x: 24.18,
  y: 19.5,
  width: 5,
  height: 5
}), /*#__PURE__*/React.createElement("rect", {
  x: 16.18,
  y: 26.5,
  width: 5,
  height: 5
}), /*#__PURE__*/React.createElement("rect", {
  x: 24.18,
  y: 26.5,
  width: 5,
  height: 5
}), /*#__PURE__*/React.createElement("polygon", {
  points: "22.68 5.5 8.53 19.5 36.82 19.5 22.68 5.5",
  fill: "#fff"
})))))));
export default SvgMobileHome;